import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';
import Router from '@/router';
import _ from 'lodash';

const state = {
  step: 1,
  forms: [],
  form: {
    id: '',
    name: '',
    schema: [],
    originS: [],
    conditions: [],
    calculations: [],
    values: []
  },
  participants: [],
  selected: [],
  loading: {
    forms: false,
    form: false,
    search: false,
    save: false
  },
  columns: [],
  resultsCount: 0
}

const mutations = {
  SET_GROUPS_STEP(state, data) {
    state.step = data
  },
  SET_GROUPS_FORMS(state, data) {
    state.forms = data
  },
  SET_GROUPS_FORM(state, data) {
    state.form.name = data.data.name
    state.form.schema = JSON.parse(data.data.data)
    state.form.originS = JSON.parse(data.data.data)
    state.form.conditions = JSON.parse(data.data.conditionals)
    state.form.calculations = JSON.parse(data.data.calculations)
    state.form.extra_validation_rules = JSON.parse(data.data.extra_validation_rules)
    state.form.hide_values = JSON.parse(data.data.hide_values);
    state.form.values = data.data.values;
    state.form.form_previews = data.data.form_previews;
    state.form.id = data.id
  },
  SET_GROUPS_PARTICIPANTS(state, data) {
    state.participants = data
  },
  SET_GROUPS_PARTICIPANTS_RESULTS_COUNT(state, data) {
    state.resultsCount = data
  },
  UPDATE_GROUPS_SELECTED(state, data) {
    if (!state.selected.includes(data)) {
      state.selected.push(data)
    } else {
      let index = state.selected.indexOf(data)
      if (index > -1) {
        state.selected.splice(index, 1)
      }
    }
  },
  SET_GROUPS_SELECTED_ALL(state, data) {
    state.selected = data
  },
  SAVE_GROUPS_FORM_SUCCESS(state, data) {
    state.step = 1
    state.selected = []
    Router.push({ name: 'Dashboard' })
  },
  SET_COLUMNS(state, data) {
    state.columns = data;
  }
}

const getters = {
  getGroupsStep: state => state.step,
  getGroupsForms: state => state.forms,
  getGroupsForm: state => state.form,
  getGroupsFormsInOrder: state => _.orderBy(state.forms, [item => item.name.toLowerCase()], ['asc']),
  getGroupsParticipants: state => state.participants,
  getGroupsSelected: state => state.selected,
  getGroupsLoadingSearch: state => state.loading.search,
  getGroupsParticipantsResultsCount: state => state.resultsCount,
  getGroupsColumns: state => state.columns
}

const actions = {
  SET_GROUPS_STEP_ACTION ({ commit }, payload) {
    commit('SET_GROUPS_STEP', payload)
  },
  UPDATE_GROUPS_SELECTED_ACTION ({ commit }, payload) {
    commit('UPDATE_GROUPS_SELECTED', payload)
  },
  SET_GROUPS_SELECTED_ALL_ACTION ({ commit }, payload) {
    commit('SET_GROUPS_SELECTED_ALL', payload)
  },
  GET_GROUPS_FORMS_ACTION: ({commit}) => {
    state.loading.forms = true
    HTTP.get(`groups`)
      .then(response => {
        ERROR(response)
        if (response.data.status === 'success') {
          commit('SET_GROUPS_FORMS', response.data.data);
          state.loading.forms = false
        }
      })
      .catch(err => {
        console.log(err)
        state.loading.forms = false
      })
  },
  GET_GROUPS_FORM_ACTION: ({commit}, payload) => {
    state.loading.form = true
    HTTP.post(`/form/get`, {id: payload})
      .then(response => {
        ERROR(response)
        if (response.data.status === 'success') {
          commit('SET_GROUPS_FORM', {data: response.data.data, id: payload});
          state.loading.form = false
        }
      })
      .catch(err => {
        console.log(err)
        state.loading.form = false
      })
  },
  GET_GROUPS_PARTICIPANTS_ACTION: ({commit}, payload) => {
    state.loading.search = true
    return HTTP.post(`search`, payload)
      .then(response => {
        ERROR(response)
        if(response.status === 200) {
          commit('SET_GROUPS_PARTICIPANTS', response.data.data.rows);
          commit('SET_GROUPS_PARTICIPANTS_RESULTS_COUNT', response.data.data.results_num);
          if (!state.columns.length) { // set columns only if are not set - workaround for vue-good-table bug
            commit('SET_COLUMNS', response.data.data.columns);
          }

          state.loading.search = false
        }
      }).catch(err => {
      console.log(err)
      state.loading.search = false
    })
  },
  SAVE_GROUPS_FORM_ACTION: ({commit}, payload) => {
    state.loading.save = true
    return HTTP.post(`groups/create`, payload)
      .then(response => {
        ERROR(response)
        if(response.status === 200) {
          commit('SAVE_GROUPS_FORM_SUCCESS', response.data)
          Vue.prototype.$notify('Form completed.');
          state.loading.save = false
        }
      }).catch(err => {
        console.log(err)
        state.loading.save = false
      })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/groups.js